import { render, staticRenderFns } from "./stockValueOnHand.vue?vue&type=template&id=770eea14&"
import script from "./stockValueOnHand.vue?vue&type=script&lang=js&"
export * from "./stockValueOnHand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports